import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from 'react-icons/fa'; // Import social media icons

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-8 px-6 sm:px-12 md:px-16 lg:px-24">
      <div className="max-w-screen-xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {/* Company Information */}
          <div className="flex flex-col justify-start">
            <h2 className="text-xl font-bold mb-2">Gravionix technologies</h2>
            <p className="text-sm mb-4">
              At Gravionix technologies, we specialize in delivering customized solutions that empower companies to leverage the latest technology to improve efficiency, enhance customer experience, and drive growth. Our dedicated team is passionate about helping businesses thrive in an ever-evolving digital landscape.
            </p>

            {/* Social Media Icons */}
            <div className="flex space-x-4 mt-4">
              <a href="https://facebook.com" className="text-white hover:text-blue-600">
                <FaFacebook size={24} />
              </a>
              <a href="https://twitter.com" className="text-white hover:text-blue-600">
                <FaTwitter size={24} />
              </a>
              <a href="https://linkedin.com" className="text-white hover:text-blue-600">
                <FaLinkedin size={24} />
              </a>
              <a href="https://instagram.com" className="text-white hover:text-blue-600">
                <FaInstagram size={24} />
              </a>
            </div>
          </div>

         {/* Useful Links */}
<div className="mx-4 sm:mx-11">
  <h3 className="text-lg sm:text-xl font-semibold mb-4">Useful Links</h3>
  <nav className="flex flex-col space-y-2">
    <Link to="/home" className="text-sm sm:text-base hover:text-blue-400">Home</Link>
    <Link to="/about" className="text-sm sm:text-base hover:text-blue-400">About Us</Link>
    <Link to="/services" className="text-sm sm:text-base hover:text-blue-400">Services</Link>
    <Link to="/blog" className="text-sm sm:text-base hover:text-blue-400">Blog</Link>
    <Link to="/contact" className="text-sm sm:text-base hover:text-blue-400">Contact</Link>
  </nav>
</div>


          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="text-sm space-y-2">
              <li><Link to="/services" className="hover:text-blue-400">Software Development</Link></li>
              <li><Link to="/services" className="hover:text-blue-400">Web Development</Link></li>
              <li><Link to="/services" className="hover:text-blue-400">App Development</Link></li>
              <li><Link to="/services" className="hover:text-blue-400">Blockchain Development</Link></li>
              <li><Link to="/services" className="hover:text-blue-400">Digital Marketing</Link></li>
              <li><Link to="/services" className="hover:text-blue-400">SEO</Link></li>
            </ul>
          </div>

         {/* Get in Touch / Newsletter */}
<div>
  <h3 className="text-lg font-semibold mb-4">Get in Touch</h3>
  <p className="text-sm mb-4">We'd love to hear from you. Reach out to us through any of the following channels:</p>
  {/* <p className="text-sm mb-2">Email: <a href="mailto:info@sigmaitinnovation.in" className="text-blue-400">info@sigmaitinnovation.in</a></p> */}
  <p className="text-sm mb-4">Address:  F038 EXPRESS ZONE MALL, A-WING, NEXT TO PATELVANIKA, W.E.HIGHWAY, GOREGAON EAST MUMBAI 400063</p>
  {/* <p className="text-sm mb-4">Mobile: <span className="text-blue-400">+1 (555) 123-4567</span></p> */}
  <p className="text-sm mb-4">Subscribe to our newsletter for updates.</p>

  {/* Form with input and button inside */}
  <form action="#" method="POST" className="flex">
    {/* Input field */}
    <input
      type="email"
      name="email"
      placeholder="Enter your email"
      className="p-2 rounded-l-md text-black w-full sm:w-auto sm:flex-grow"
      required
    />
    {/* Subscribe Button inside the input */}
    <button
      type="submit"
      className="bg-blue-500 text-white p-2 rounded-r-md hover:bg-blue-600"
    >
      Subscribe
    </button>
  </form>
</div>

        </div>

        {/* Copyright Centered */}
        <div className="mt-8 flex justify-center">
          <p className="text-sm text-center">&copy; 2025 Gravionix technologies. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
